<template>
  <v-dialog v-model="servicesModal" max-width="900px">
    <template v-slot:activator="{ on }">
      <v-chip v-on="on">{{ !services ? '0' : services.length}}</v-chip>
    </template>
    <v-card>
      <v-toolbar dark color="primary" class="mx-auto">
        <v-card-title color="primary">Services</v-card-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="servicesModal = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table :items="services" :headers="servicesHeaders">
        <template v-slot:item.CPT_HCPCS="{ item }">
          {{ item.CPT_HCPCS || '-' }}
        </template>
        <template v-slot:item.DIAG="{ item }">
          {{ item.DIAG || '-' }}
        </template>
        <template v-slot:item.SERVICE_DESC="{ item }">
          {{ item.SERVICE_DESC }}
        </template>
        <template v-slot:item.UNITS="{ item }">
          {{ item.UNITS }}
        </template>
        <template v-slot:item.APPROVED_UNTIS="{ item }">
          {{ item.Approved_Units }}
        </template>
        <template v-slot:item.APPROVED_VISITS="{ item }">
          {{ item.APPROVED_VISITS }}
        </template>
        <template v-slot:item.VISITS="{ item }">
          {{ item.VISITS }}
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AuthServicesModal',
  props: ['services'],
  data() {
    return {
      servicesHeaders: [
        { text: 'CPT/HCPCS', value: 'CPT_HCPCS' },
        { text: 'Diagnosis', value: 'DIAG' },
        { text: 'Description', value: 'SERVICE_DESC' },
        { text: 'Requesting Units', value: 'UNITS' },
        { text: 'Approved Units', value: 'APPROVED_UNITS' },
        { text: 'Approved Visits', value: 'APPROVED_UNITS' },
        { text: 'Requesting Visits', value: 'VISITS' },
      ],
      servicesModal: false,
    };
  },
};
</script>

<style scoped></style>
